import { Component } from "@angular/core";
import {
  AlertController,
  IonicPage,
  NavController,
  NavParams,
  ToastController,
} from "ionic-angular";

/**
 * Generated class for the SubscribeNotificationSuccessfulPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage({
  segment: "subscribe-notification-successful/:id",
})
@Component({
  selector: "page-subscribe-notification-successful",
  templateUrl: "subscribe-notification-successful.html",
})
export class SubscribeNotificationSuccessfulPage {
  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    private alertCtrl: AlertController
  ) {}

  ionViewDidLoad() {
    setTimeout(() => {
      window.location.hash = "/campaign/" + this.navParams.data.id;
    }, 500);

    this.alertCtrl
      .create({
        title: "通知订阅成功",
        subTitle:
          "达到成团人数时，我们会通过服务消息在微信上通知您。<br/>请点击右上角图标，邀请好友们一起来参团，以尽快达到成团人数。",
        buttons: [
          {
            text: "好",
          },
        ],
      })
      .present();
  }
}



// WEBPACK FOOTER //
// ./src/pages/subscribe-notification-successful/subscribe-notification-successful.ts